<template>
  <div v-if="activeVariations.length" class="paragraph">
    <PDPTeaserSlider
      v-model="selected"
      :variations="filteredVariations"
      :title="$texts('variations', 'Variations')"
      :options="options"
    />
  </div>
</template>

<script
  setup
  lang="ts"
  generic="
    T extends
      | ProductVariationWatchTeaserFragment
      | ProductVariationStrapTeaserFragment
      | ProductFinderItemFragment
  "
>
import { ref } from 'vue'

import type { DropdownItem } from '~/components/Input/Dropdown.vue'
import type {
  ProductVariationWatchTeaserFragment,
  ProductVariationStrapTeaserFragment,
  ProductFinderItemFragment,
} from '#build/graphql-operations'

const props = defineProps<{
  variations: T[]
  groupBy?: keyof T
  intialValue?: string
}>()

const { $texts } = useEasyTexts()

const activeVariations = computed(() =>
  props.variations.filter(
    (v) => v && 'isArchived' in v && 'status' in v && !v.isArchived && v.status,
  ),
)

const options = computed(() => {
  if (!props.groupBy) {
    return []
  }
  const grouped = activeVariations.value.reduce<Record<string, DropdownItem>>(
    (acc, v) => {
      if (!props.groupBy) {
        return acc
      }
      const fieldValue = v[props.groupBy]
      if (typeof fieldValue === 'string' && !acc[fieldValue]) {
        acc[fieldValue] = {
          value: fieldValue,
          label: fieldValue,
        }
      }

      return acc
    },
    {},
  )

  const sortedOptions = Object.values(grouped).sort((a, b) => {
    if (a.value < b.value) {
      return -1
    }
    if (a.value > b.value) {
      return 1
    }
    return 0
  })

  return sortedOptions
})

const selected = ref(props.intialValue || options.value[0]?.value)

const filteredVariations = computed(() =>
  activeVariations.value.filter((v) => {
    if (props.groupBy && selected.value) {
      const fieldValue = v[props.groupBy]
      return fieldValue === selected.value
    }

    return true
  }),
)
</script>
